module.exports = __webpack_public_path__ + "static/media/blueDart.c1ea8578.svg";